import StoreCard from './store-card';
import Pagination from 'rc-pagination';
import { ReactNode } from 'react';
import { RenderProps } from '../../store-cards';

const PaginationItem = (page: number, type: string, element: ReactNode) => {
    switch (type) {
        case 'page': {
            return <div className="ui-pagination-nav__item">{page}</div>;
        }
        case 'prev': {
            return (
                <div className="ui-pagination-nav__item ui-pagination-nav__item--prev">
                    <i className="icon-arrow-left" />
                </div>
            );
        }
        case 'next': {
            return (
                <div className="ui-pagination-nav__item ui-pagination-nav__item--next">
                    <i className="icon-arrow-right" />
                </div>
            );
        }
        case 'jump-prev':
        case 'jump-next': {
            return <div className="ui-pagination-nav__item">...</div>;
        }
    }
    return element;
};

export default function StoreList({ stores, total, page, setPage, pageSize }: RenderProps) {
    return (
        <div className="w-100">
            <section className="w-100">
                <div className="data-container">
                    <div className="partners-items">
                        {stores.map((s) => (
                            <StoreCard key={s.id} store={s} />
                        ))}
                    </div>
                </div>
                <div>
                    <div className="ui-pagination">
                        <Pagination
                            className="ui-pagination-nav"
                            pageSize={pageSize}
                            current={page}
                            showLessItems
                            onChange={setPage}
                            total={total}
                            itemRender={PaginationItem}
                            showTitle={false}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
}
